/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as TransactionsRouteImport } from './routes/transactions'
import { Route as TimelineRouteImport } from './routes/timeline'
import { Route as SnapshotsRouteImport } from './routes/snapshots'
import { Route as SettingsAiRouteImport } from './routes/settings-ai'
import { Route as RiskRouteImport } from './routes/risk'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as RecurringTransactionsRouteImport } from './routes/recurring-transactions'
import { Route as RecommendationsRouteImport } from './routes/recommendations'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as PerformanceRouteImport } from './routes/performance'
import { Route as PaymentGridRouteImport } from './routes/payment-grid'
import { Route as NetWorthRouteImport } from './routes/net-worth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as InvestmentPlanRouteImport } from './routes/investment-plan'
import { Route as ImportExportRouteImport } from './routes/import-export'
import { Route as HouseholdRouteImport } from './routes/household'
import { Route as HoldingsRouteImport } from './routes/holdings'
import { Route as GoalsRouteImport } from './routes/goals'
import { Route as FlowRouteImport } from './routes/flow'
import { Route as FireRouteImport } from './routes/fire'
import { Route as FeesRouteImport } from './routes/fees'
import { Route as ExtensionsRouteImport } from './routes/extensions'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as DividendsRouteImport } from './routes/dividends'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ContributionRoomRouteImport } from './routes/contribution-room'
import { Route as ConsolidatedHoldingsRouteImport } from './routes/consolidated-holdings'
import { Route as ConnectionsRouteImport } from './routes/connections'
import { Route as CategorizationRulesRouteImport } from './routes/categorization-rules'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as BudgetsRouteImport } from './routes/budgets'
import { Route as BillsRouteImport } from './routes/bills'
import { Route as ApiTokensRouteImport } from './routes/api-tokens'
import { Route as ApiDocsRouteImport } from './routes/api-docs'
import { Route as AllocationRouteImport } from './routes/allocation'
import { Route as AdminUsersRouteImport } from './routes/admin-users'
import { Route as ActivityFeedRouteImport } from './routes/activity-feed'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as AccountsBrowserRouteImport } from './routes/accounts-browser'
import { Route as AccountsRouteImport } from './routes/accounts'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DocsIndexRouteImport } from './routes/docs.index'
import { Route as AnalysisIndexRouteImport } from './routes/analysis.index'
import { Route as DocsReferenceRouteImport } from './routes/docs.reference'
import { Route as DocsReconciliationRouteImport } from './routes/docs.reconciliation'
import { Route as DocsPerformanceRouteImport } from './routes/docs.performance'
import { Route as DocsPaymentGridRouteImport } from './routes/docs.payment-grid'
import { Route as DocsInvestmentsRouteImport } from './routes/docs.investments'
import { Route as DocsImportingRouteImport } from './routes/docs.importing'
import { Route as DocsFlowMapRouteImport } from './routes/docs.flow-map'
import { Route as DocsFireRouteImport } from './routes/docs.fire'
import { Route as DocsDoubleEntryRouteImport } from './routes/docs.double-entry'
import { Route as DocsContributionRoomRouteImport } from './routes/docs.contribution-room'
import { Route as DocsBillsRouteImport } from './routes/docs.bills'
import { Route as DocsAutomatingRouteImport } from './routes/docs.automating'
import { Route as DocsAiInsightsRouteImport } from './routes/docs.ai-insights'
import { Route as DocsAccountsRouteImport } from './routes/docs.accounts'
import { Route as AnalysisIdRouteImport } from './routes/analysis.$id'
import { Route as AccountsIdRouteImport } from './routes/accounts.$id'

const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsRoute = TransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const TimelineRoute = TimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => rootRouteImport,
} as any)
const SnapshotsRoute = SnapshotsRouteImport.update({
  id: '/snapshots',
  path: '/snapshots',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAiRoute = SettingsAiRouteImport.update({
  id: '/settings-ai',
  path: '/settings-ai',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskRoute = RiskRouteImport.update({
  id: '/risk',
  path: '/risk',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const RecurringTransactionsRoute = RecurringTransactionsRouteImport.update({
  id: '/recurring-transactions',
  path: '/recurring-transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const RecommendationsRoute = RecommendationsRouteImport.update({
  id: '/recommendations',
  path: '/recommendations',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioRoute = PortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => rootRouteImport,
} as any)
const PerformanceRoute = PerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentGridRoute = PaymentGridRouteImport.update({
  id: '/payment-grid',
  path: '/payment-grid',
  getParentRoute: () => rootRouteImport,
} as any)
const NetWorthRoute = NetWorthRouteImport.update({
  id: '/net-worth',
  path: '/net-worth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const InvestmentPlanRoute = InvestmentPlanRouteImport.update({
  id: '/investment-plan',
  path: '/investment-plan',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportExportRoute = ImportExportRouteImport.update({
  id: '/import-export',
  path: '/import-export',
  getParentRoute: () => rootRouteImport,
} as any)
const HouseholdRoute = HouseholdRouteImport.update({
  id: '/household',
  path: '/household',
  getParentRoute: () => rootRouteImport,
} as any)
const HoldingsRoute = HoldingsRouteImport.update({
  id: '/holdings',
  path: '/holdings',
  getParentRoute: () => rootRouteImport,
} as any)
const GoalsRoute = GoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => rootRouteImport,
} as any)
const FlowRoute = FlowRouteImport.update({
  id: '/flow',
  path: '/flow',
  getParentRoute: () => rootRouteImport,
} as any)
const FireRoute = FireRouteImport.update({
  id: '/fire',
  path: '/fire',
  getParentRoute: () => rootRouteImport,
} as any)
const FeesRoute = FeesRouteImport.update({
  id: '/fees',
  path: '/fees',
  getParentRoute: () => rootRouteImport,
} as any)
const ExtensionsRoute = ExtensionsRouteImport.update({
  id: '/extensions',
  path: '/extensions',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const DividendsRoute = DividendsRouteImport.update({
  id: '/dividends',
  path: '/dividends',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ContributionRoomRoute = ContributionRoomRouteImport.update({
  id: '/contribution-room',
  path: '/contribution-room',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsolidatedHoldingsRoute = ConsolidatedHoldingsRouteImport.update({
  id: '/consolidated-holdings',
  path: '/consolidated-holdings',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectionsRoute = ConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => rootRouteImport,
} as any)
const CategorizationRulesRoute = CategorizationRulesRouteImport.update({
  id: '/categorization-rules',
  path: '/categorization-rules',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesRoute = CategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetsRoute = BudgetsRouteImport.update({
  id: '/budgets',
  path: '/budgets',
  getParentRoute: () => rootRouteImport,
} as any)
const BillsRoute = BillsRouteImport.update({
  id: '/bills',
  path: '/bills',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiTokensRoute = ApiTokensRouteImport.update({
  id: '/api-tokens',
  path: '/api-tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiDocsRoute = ApiDocsRouteImport.update({
  id: '/api-docs',
  path: '/api-docs',
  getParentRoute: () => rootRouteImport,
} as any)
const AllocationRoute = AllocationRouteImport.update({
  id: '/allocation',
  path: '/allocation',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin-users',
  path: '/admin-users',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityFeedRoute = ActivityFeedRouteImport.update({
  id: '/activity-feed',
  path: '/activity-feed',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsBrowserRoute = AccountsBrowserRouteImport.update({
  id: '/accounts-browser',
  path: '/accounts-browser',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsRoute = AccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocsRoute,
} as any)
const AnalysisIndexRoute = AnalysisIndexRouteImport.update({
  id: '/analysis/',
  path: '/analysis/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsReferenceRoute = DocsReferenceRouteImport.update({
  id: '/reference',
  path: '/reference',
  getParentRoute: () => DocsRoute,
} as any)
const DocsReconciliationRoute = DocsReconciliationRouteImport.update({
  id: '/reconciliation',
  path: '/reconciliation',
  getParentRoute: () => DocsRoute,
} as any)
const DocsPerformanceRoute = DocsPerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => DocsRoute,
} as any)
const DocsPaymentGridRoute = DocsPaymentGridRouteImport.update({
  id: '/payment-grid',
  path: '/payment-grid',
  getParentRoute: () => DocsRoute,
} as any)
const DocsInvestmentsRoute = DocsInvestmentsRouteImport.update({
  id: '/investments',
  path: '/investments',
  getParentRoute: () => DocsRoute,
} as any)
const DocsImportingRoute = DocsImportingRouteImport.update({
  id: '/importing',
  path: '/importing',
  getParentRoute: () => DocsRoute,
} as any)
const DocsFlowMapRoute = DocsFlowMapRouteImport.update({
  id: '/flow-map',
  path: '/flow-map',
  getParentRoute: () => DocsRoute,
} as any)
const DocsFireRoute = DocsFireRouteImport.update({
  id: '/fire',
  path: '/fire',
  getParentRoute: () => DocsRoute,
} as any)
const DocsDoubleEntryRoute = DocsDoubleEntryRouteImport.update({
  id: '/double-entry',
  path: '/double-entry',
  getParentRoute: () => DocsRoute,
} as any)
const DocsContributionRoomRoute = DocsContributionRoomRouteImport.update({
  id: '/contribution-room',
  path: '/contribution-room',
  getParentRoute: () => DocsRoute,
} as any)
const DocsBillsRoute = DocsBillsRouteImport.update({
  id: '/bills',
  path: '/bills',
  getParentRoute: () => DocsRoute,
} as any)
const DocsAutomatingRoute = DocsAutomatingRouteImport.update({
  id: '/automating',
  path: '/automating',
  getParentRoute: () => DocsRoute,
} as any)
const DocsAiInsightsRoute = DocsAiInsightsRouteImport.update({
  id: '/ai-insights',
  path: '/ai-insights',
  getParentRoute: () => DocsRoute,
} as any)
const DocsAccountsRoute = DocsAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => DocsRoute,
} as any)
const AnalysisIdRoute = AnalysisIdRouteImport.update({
  id: '/analysis/$id',
  path: '/analysis/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsIdRoute = AccountsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AccountsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accounts': typeof AccountsRouteWithChildren
  '/accounts-browser': typeof AccountsBrowserRoute
  '/activity': typeof ActivityRoute
  '/activity-feed': typeof ActivityFeedRoute
  '/admin-users': typeof AdminUsersRoute
  '/allocation': typeof AllocationRoute
  '/api-docs': typeof ApiDocsRoute
  '/api-tokens': typeof ApiTokensRoute
  '/bills': typeof BillsRoute
  '/budgets': typeof BudgetsRoute
  '/categories': typeof CategoriesRoute
  '/categorization-rules': typeof CategorizationRulesRoute
  '/connections': typeof ConnectionsRoute
  '/consolidated-holdings': typeof ConsolidatedHoldingsRoute
  '/contribution-room': typeof ContributionRoomRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/dividends': typeof DividendsRoute
  '/docs': typeof DocsRouteWithChildren
  '/extensions': typeof ExtensionsRoute
  '/fees': typeof FeesRoute
  '/fire': typeof FireRoute
  '/flow': typeof FlowRoute
  '/goals': typeof GoalsRoute
  '/holdings': typeof HoldingsRoute
  '/household': typeof HouseholdRoute
  '/import-export': typeof ImportExportRoute
  '/investment-plan': typeof InvestmentPlanRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/net-worth': typeof NetWorthRoute
  '/payment-grid': typeof PaymentGridRoute
  '/performance': typeof PerformanceRoute
  '/portfolio': typeof PortfolioRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/recommendations': typeof RecommendationsRoute
  '/recurring-transactions': typeof RecurringTransactionsRoute
  '/register': typeof RegisterRoute
  '/reports': typeof ReportsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/risk': typeof RiskRoute
  '/settings-ai': typeof SettingsAiRoute
  '/snapshots': typeof SnapshotsRoute
  '/timeline': typeof TimelineRoute
  '/transactions': typeof TransactionsRoute
  '/verify': typeof VerifyRoute
  '/accounts/$id': typeof AccountsIdRoute
  '/analysis/$id': typeof AnalysisIdRoute
  '/docs/accounts': typeof DocsAccountsRoute
  '/docs/ai-insights': typeof DocsAiInsightsRoute
  '/docs/automating': typeof DocsAutomatingRoute
  '/docs/bills': typeof DocsBillsRoute
  '/docs/contribution-room': typeof DocsContributionRoomRoute
  '/docs/double-entry': typeof DocsDoubleEntryRoute
  '/docs/fire': typeof DocsFireRoute
  '/docs/flow-map': typeof DocsFlowMapRoute
  '/docs/importing': typeof DocsImportingRoute
  '/docs/investments': typeof DocsInvestmentsRoute
  '/docs/payment-grid': typeof DocsPaymentGridRoute
  '/docs/performance': typeof DocsPerformanceRoute
  '/docs/reconciliation': typeof DocsReconciliationRoute
  '/docs/reference': typeof DocsReferenceRoute
  '/analysis/': typeof AnalysisIndexRoute
  '/docs/': typeof DocsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accounts': typeof AccountsRouteWithChildren
  '/accounts-browser': typeof AccountsBrowserRoute
  '/activity': typeof ActivityRoute
  '/activity-feed': typeof ActivityFeedRoute
  '/admin-users': typeof AdminUsersRoute
  '/allocation': typeof AllocationRoute
  '/api-docs': typeof ApiDocsRoute
  '/api-tokens': typeof ApiTokensRoute
  '/bills': typeof BillsRoute
  '/budgets': typeof BudgetsRoute
  '/categories': typeof CategoriesRoute
  '/categorization-rules': typeof CategorizationRulesRoute
  '/connections': typeof ConnectionsRoute
  '/consolidated-holdings': typeof ConsolidatedHoldingsRoute
  '/contribution-room': typeof ContributionRoomRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/dividends': typeof DividendsRoute
  '/extensions': typeof ExtensionsRoute
  '/fees': typeof FeesRoute
  '/fire': typeof FireRoute
  '/flow': typeof FlowRoute
  '/goals': typeof GoalsRoute
  '/holdings': typeof HoldingsRoute
  '/household': typeof HouseholdRoute
  '/import-export': typeof ImportExportRoute
  '/investment-plan': typeof InvestmentPlanRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/net-worth': typeof NetWorthRoute
  '/payment-grid': typeof PaymentGridRoute
  '/performance': typeof PerformanceRoute
  '/portfolio': typeof PortfolioRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/recommendations': typeof RecommendationsRoute
  '/recurring-transactions': typeof RecurringTransactionsRoute
  '/register': typeof RegisterRoute
  '/reports': typeof ReportsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/risk': typeof RiskRoute
  '/settings-ai': typeof SettingsAiRoute
  '/snapshots': typeof SnapshotsRoute
  '/timeline': typeof TimelineRoute
  '/transactions': typeof TransactionsRoute
  '/verify': typeof VerifyRoute
  '/accounts/$id': typeof AccountsIdRoute
  '/analysis/$id': typeof AnalysisIdRoute
  '/docs/accounts': typeof DocsAccountsRoute
  '/docs/ai-insights': typeof DocsAiInsightsRoute
  '/docs/automating': typeof DocsAutomatingRoute
  '/docs/bills': typeof DocsBillsRoute
  '/docs/contribution-room': typeof DocsContributionRoomRoute
  '/docs/double-entry': typeof DocsDoubleEntryRoute
  '/docs/fire': typeof DocsFireRoute
  '/docs/flow-map': typeof DocsFlowMapRoute
  '/docs/importing': typeof DocsImportingRoute
  '/docs/investments': typeof DocsInvestmentsRoute
  '/docs/payment-grid': typeof DocsPaymentGridRoute
  '/docs/performance': typeof DocsPerformanceRoute
  '/docs/reconciliation': typeof DocsReconciliationRoute
  '/docs/reference': typeof DocsReferenceRoute
  '/analysis': typeof AnalysisIndexRoute
  '/docs': typeof DocsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accounts': typeof AccountsRouteWithChildren
  '/accounts-browser': typeof AccountsBrowserRoute
  '/activity': typeof ActivityRoute
  '/activity-feed': typeof ActivityFeedRoute
  '/admin-users': typeof AdminUsersRoute
  '/allocation': typeof AllocationRoute
  '/api-docs': typeof ApiDocsRoute
  '/api-tokens': typeof ApiTokensRoute
  '/bills': typeof BillsRoute
  '/budgets': typeof BudgetsRoute
  '/categories': typeof CategoriesRoute
  '/categorization-rules': typeof CategorizationRulesRoute
  '/connections': typeof ConnectionsRoute
  '/consolidated-holdings': typeof ConsolidatedHoldingsRoute
  '/contribution-room': typeof ContributionRoomRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/dividends': typeof DividendsRoute
  '/docs': typeof DocsRouteWithChildren
  '/extensions': typeof ExtensionsRoute
  '/fees': typeof FeesRoute
  '/fire': typeof FireRoute
  '/flow': typeof FlowRoute
  '/goals': typeof GoalsRoute
  '/holdings': typeof HoldingsRoute
  '/household': typeof HouseholdRoute
  '/import-export': typeof ImportExportRoute
  '/investment-plan': typeof InvestmentPlanRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/net-worth': typeof NetWorthRoute
  '/payment-grid': typeof PaymentGridRoute
  '/performance': typeof PerformanceRoute
  '/portfolio': typeof PortfolioRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/recommendations': typeof RecommendationsRoute
  '/recurring-transactions': typeof RecurringTransactionsRoute
  '/register': typeof RegisterRoute
  '/reports': typeof ReportsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/risk': typeof RiskRoute
  '/settings-ai': typeof SettingsAiRoute
  '/snapshots': typeof SnapshotsRoute
  '/timeline': typeof TimelineRoute
  '/transactions': typeof TransactionsRoute
  '/verify': typeof VerifyRoute
  '/accounts/$id': typeof AccountsIdRoute
  '/analysis/$id': typeof AnalysisIdRoute
  '/docs/accounts': typeof DocsAccountsRoute
  '/docs/ai-insights': typeof DocsAiInsightsRoute
  '/docs/automating': typeof DocsAutomatingRoute
  '/docs/bills': typeof DocsBillsRoute
  '/docs/contribution-room': typeof DocsContributionRoomRoute
  '/docs/double-entry': typeof DocsDoubleEntryRoute
  '/docs/fire': typeof DocsFireRoute
  '/docs/flow-map': typeof DocsFlowMapRoute
  '/docs/importing': typeof DocsImportingRoute
  '/docs/investments': typeof DocsInvestmentsRoute
  '/docs/payment-grid': typeof DocsPaymentGridRoute
  '/docs/performance': typeof DocsPerformanceRoute
  '/docs/reconciliation': typeof DocsReconciliationRoute
  '/docs/reference': typeof DocsReferenceRoute
  '/analysis/': typeof AnalysisIndexRoute
  '/docs/': typeof DocsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accounts'
    | '/accounts-browser'
    | '/activity'
    | '/activity-feed'
    | '/admin-users'
    | '/allocation'
    | '/api-docs'
    | '/api-tokens'
    | '/bills'
    | '/budgets'
    | '/categories'
    | '/categorization-rules'
    | '/connections'
    | '/consolidated-holdings'
    | '/contribution-room'
    | '/dashboard'
    | '/demo'
    | '/dividends'
    | '/docs'
    | '/extensions'
    | '/fees'
    | '/fire'
    | '/flow'
    | '/goals'
    | '/holdings'
    | '/household'
    | '/import-export'
    | '/investment-plan'
    | '/invite'
    | '/login'
    | '/net-worth'
    | '/payment-grid'
    | '/performance'
    | '/portfolio'
    | '/pricing'
    | '/profile'
    | '/recommendations'
    | '/recurring-transactions'
    | '/register'
    | '/reports'
    | '/reset-password'
    | '/risk'
    | '/settings-ai'
    | '/snapshots'
    | '/timeline'
    | '/transactions'
    | '/verify'
    | '/accounts/$id'
    | '/analysis/$id'
    | '/docs/accounts'
    | '/docs/ai-insights'
    | '/docs/automating'
    | '/docs/bills'
    | '/docs/contribution-room'
    | '/docs/double-entry'
    | '/docs/fire'
    | '/docs/flow-map'
    | '/docs/importing'
    | '/docs/investments'
    | '/docs/payment-grid'
    | '/docs/performance'
    | '/docs/reconciliation'
    | '/docs/reference'
    | '/analysis/'
    | '/docs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accounts'
    | '/accounts-browser'
    | '/activity'
    | '/activity-feed'
    | '/admin-users'
    | '/allocation'
    | '/api-docs'
    | '/api-tokens'
    | '/bills'
    | '/budgets'
    | '/categories'
    | '/categorization-rules'
    | '/connections'
    | '/consolidated-holdings'
    | '/contribution-room'
    | '/dashboard'
    | '/demo'
    | '/dividends'
    | '/extensions'
    | '/fees'
    | '/fire'
    | '/flow'
    | '/goals'
    | '/holdings'
    | '/household'
    | '/import-export'
    | '/investment-plan'
    | '/invite'
    | '/login'
    | '/net-worth'
    | '/payment-grid'
    | '/performance'
    | '/portfolio'
    | '/pricing'
    | '/profile'
    | '/recommendations'
    | '/recurring-transactions'
    | '/register'
    | '/reports'
    | '/reset-password'
    | '/risk'
    | '/settings-ai'
    | '/snapshots'
    | '/timeline'
    | '/transactions'
    | '/verify'
    | '/accounts/$id'
    | '/analysis/$id'
    | '/docs/accounts'
    | '/docs/ai-insights'
    | '/docs/automating'
    | '/docs/bills'
    | '/docs/contribution-room'
    | '/docs/double-entry'
    | '/docs/fire'
    | '/docs/flow-map'
    | '/docs/importing'
    | '/docs/investments'
    | '/docs/payment-grid'
    | '/docs/performance'
    | '/docs/reconciliation'
    | '/docs/reference'
    | '/analysis'
    | '/docs'
  id:
    | '__root__'
    | '/'
    | '/accounts'
    | '/accounts-browser'
    | '/activity'
    | '/activity-feed'
    | '/admin-users'
    | '/allocation'
    | '/api-docs'
    | '/api-tokens'
    | '/bills'
    | '/budgets'
    | '/categories'
    | '/categorization-rules'
    | '/connections'
    | '/consolidated-holdings'
    | '/contribution-room'
    | '/dashboard'
    | '/demo'
    | '/dividends'
    | '/docs'
    | '/extensions'
    | '/fees'
    | '/fire'
    | '/flow'
    | '/goals'
    | '/holdings'
    | '/household'
    | '/import-export'
    | '/investment-plan'
    | '/invite'
    | '/login'
    | '/net-worth'
    | '/payment-grid'
    | '/performance'
    | '/portfolio'
    | '/pricing'
    | '/profile'
    | '/recommendations'
    | '/recurring-transactions'
    | '/register'
    | '/reports'
    | '/reset-password'
    | '/risk'
    | '/settings-ai'
    | '/snapshots'
    | '/timeline'
    | '/transactions'
    | '/verify'
    | '/accounts/$id'
    | '/analysis/$id'
    | '/docs/accounts'
    | '/docs/ai-insights'
    | '/docs/automating'
    | '/docs/bills'
    | '/docs/contribution-room'
    | '/docs/double-entry'
    | '/docs/fire'
    | '/docs/flow-map'
    | '/docs/importing'
    | '/docs/investments'
    | '/docs/payment-grid'
    | '/docs/performance'
    | '/docs/reconciliation'
    | '/docs/reference'
    | '/analysis/'
    | '/docs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountsRoute: typeof AccountsRouteWithChildren
  AccountsBrowserRoute: typeof AccountsBrowserRoute
  ActivityRoute: typeof ActivityRoute
  ActivityFeedRoute: typeof ActivityFeedRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AllocationRoute: typeof AllocationRoute
  ApiDocsRoute: typeof ApiDocsRoute
  ApiTokensRoute: typeof ApiTokensRoute
  BillsRoute: typeof BillsRoute
  BudgetsRoute: typeof BudgetsRoute
  CategoriesRoute: typeof CategoriesRoute
  CategorizationRulesRoute: typeof CategorizationRulesRoute
  ConnectionsRoute: typeof ConnectionsRoute
  ConsolidatedHoldingsRoute: typeof ConsolidatedHoldingsRoute
  ContributionRoomRoute: typeof ContributionRoomRoute
  DashboardRoute: typeof DashboardRoute
  DemoRoute: typeof DemoRoute
  DividendsRoute: typeof DividendsRoute
  DocsRoute: typeof DocsRouteWithChildren
  ExtensionsRoute: typeof ExtensionsRoute
  FeesRoute: typeof FeesRoute
  FireRoute: typeof FireRoute
  FlowRoute: typeof FlowRoute
  GoalsRoute: typeof GoalsRoute
  HoldingsRoute: typeof HoldingsRoute
  HouseholdRoute: typeof HouseholdRoute
  ImportExportRoute: typeof ImportExportRoute
  InvestmentPlanRoute: typeof InvestmentPlanRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  NetWorthRoute: typeof NetWorthRoute
  PaymentGridRoute: typeof PaymentGridRoute
  PerformanceRoute: typeof PerformanceRoute
  PortfolioRoute: typeof PortfolioRoute
  PricingRoute: typeof PricingRoute
  ProfileRoute: typeof ProfileRoute
  RecommendationsRoute: typeof RecommendationsRoute
  RecurringTransactionsRoute: typeof RecurringTransactionsRoute
  RegisterRoute: typeof RegisterRoute
  ReportsRoute: typeof ReportsRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  RiskRoute: typeof RiskRoute
  SettingsAiRoute: typeof SettingsAiRoute
  SnapshotsRoute: typeof SnapshotsRoute
  TimelineRoute: typeof TimelineRoute
  TransactionsRoute: typeof TransactionsRoute
  VerifyRoute: typeof VerifyRoute
  AnalysisIdRoute: typeof AnalysisIdRoute
  AnalysisIndexRoute: typeof AnalysisIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/timeline': {
      id: '/timeline'
      path: '/timeline'
      fullPath: '/timeline'
      preLoaderRoute: typeof TimelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/snapshots': {
      id: '/snapshots'
      path: '/snapshots'
      fullPath: '/snapshots'
      preLoaderRoute: typeof SnapshotsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings-ai': {
      id: '/settings-ai'
      path: '/settings-ai'
      fullPath: '/settings-ai'
      preLoaderRoute: typeof SettingsAiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk': {
      id: '/risk'
      path: '/risk'
      fullPath: '/risk'
      preLoaderRoute: typeof RiskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recurring-transactions': {
      id: '/recurring-transactions'
      path: '/recurring-transactions'
      fullPath: '/recurring-transactions'
      preLoaderRoute: typeof RecurringTransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recommendations': {
      id: '/recommendations'
      path: '/recommendations'
      fullPath: '/recommendations'
      preLoaderRoute: typeof RecommendationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio': {
      id: '/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof PortfolioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/performance': {
      id: '/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof PerformanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-grid': {
      id: '/payment-grid'
      path: '/payment-grid'
      fullPath: '/payment-grid'
      preLoaderRoute: typeof PaymentGridRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/net-worth': {
      id: '/net-worth'
      path: '/net-worth'
      fullPath: '/net-worth'
      preLoaderRoute: typeof NetWorthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/investment-plan': {
      id: '/investment-plan'
      path: '/investment-plan'
      fullPath: '/investment-plan'
      preLoaderRoute: typeof InvestmentPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import-export': {
      id: '/import-export'
      path: '/import-export'
      fullPath: '/import-export'
      preLoaderRoute: typeof ImportExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/household': {
      id: '/household'
      path: '/household'
      fullPath: '/household'
      preLoaderRoute: typeof HouseholdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/holdings': {
      id: '/holdings'
      path: '/holdings'
      fullPath: '/holdings'
      preLoaderRoute: typeof HoldingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/goals': {
      id: '/goals'
      path: '/goals'
      fullPath: '/goals'
      preLoaderRoute: typeof GoalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flow': {
      id: '/flow'
      path: '/flow'
      fullPath: '/flow'
      preLoaderRoute: typeof FlowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fire': {
      id: '/fire'
      path: '/fire'
      fullPath: '/fire'
      preLoaderRoute: typeof FireRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fees': {
      id: '/fees'
      path: '/fees'
      fullPath: '/fees'
      preLoaderRoute: typeof FeesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/extensions': {
      id: '/extensions'
      path: '/extensions'
      fullPath: '/extensions'
      preLoaderRoute: typeof ExtensionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dividends': {
      id: '/dividends'
      path: '/dividends'
      fullPath: '/dividends'
      preLoaderRoute: typeof DividendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contribution-room': {
      id: '/contribution-room'
      path: '/contribution-room'
      fullPath: '/contribution-room'
      preLoaderRoute: typeof ContributionRoomRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consolidated-holdings': {
      id: '/consolidated-holdings'
      path: '/consolidated-holdings'
      fullPath: '/consolidated-holdings'
      preLoaderRoute: typeof ConsolidatedHoldingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connections': {
      id: '/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof ConnectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categorization-rules': {
      id: '/categorization-rules'
      path: '/categorization-rules'
      fullPath: '/categorization-rules'
      preLoaderRoute: typeof CategorizationRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories': {
      id: '/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof CategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgets': {
      id: '/budgets'
      path: '/budgets'
      fullPath: '/budgets'
      preLoaderRoute: typeof BudgetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bills': {
      id: '/bills'
      path: '/bills'
      fullPath: '/bills'
      preLoaderRoute: typeof BillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-tokens': {
      id: '/api-tokens'
      path: '/api-tokens'
      fullPath: '/api-tokens'
      preLoaderRoute: typeof ApiTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-docs': {
      id: '/api-docs'
      path: '/api-docs'
      fullPath: '/api-docs'
      preLoaderRoute: typeof ApiDocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/allocation': {
      id: '/allocation'
      path: '/allocation'
      fullPath: '/allocation'
      preLoaderRoute: typeof AllocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-users': {
      id: '/admin-users'
      path: '/admin-users'
      fullPath: '/admin-users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity-feed': {
      id: '/activity-feed'
      path: '/activity-feed'
      fullPath: '/activity-feed'
      preLoaderRoute: typeof ActivityFeedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts-browser': {
      id: '/accounts-browser'
      path: '/accounts-browser'
      fullPath: '/accounts-browser'
      preLoaderRoute: typeof AccountsBrowserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts': {
      id: '/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/': {
      id: '/docs/'
      path: '/'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof DocsRoute
    }
    '/analysis/': {
      id: '/analysis/'
      path: '/analysis'
      fullPath: '/analysis/'
      preLoaderRoute: typeof AnalysisIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/reference': {
      id: '/docs/reference'
      path: '/reference'
      fullPath: '/docs/reference'
      preLoaderRoute: typeof DocsReferenceRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/reconciliation': {
      id: '/docs/reconciliation'
      path: '/reconciliation'
      fullPath: '/docs/reconciliation'
      preLoaderRoute: typeof DocsReconciliationRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/performance': {
      id: '/docs/performance'
      path: '/performance'
      fullPath: '/docs/performance'
      preLoaderRoute: typeof DocsPerformanceRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/payment-grid': {
      id: '/docs/payment-grid'
      path: '/payment-grid'
      fullPath: '/docs/payment-grid'
      preLoaderRoute: typeof DocsPaymentGridRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/investments': {
      id: '/docs/investments'
      path: '/investments'
      fullPath: '/docs/investments'
      preLoaderRoute: typeof DocsInvestmentsRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/importing': {
      id: '/docs/importing'
      path: '/importing'
      fullPath: '/docs/importing'
      preLoaderRoute: typeof DocsImportingRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/flow-map': {
      id: '/docs/flow-map'
      path: '/flow-map'
      fullPath: '/docs/flow-map'
      preLoaderRoute: typeof DocsFlowMapRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/fire': {
      id: '/docs/fire'
      path: '/fire'
      fullPath: '/docs/fire'
      preLoaderRoute: typeof DocsFireRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/double-entry': {
      id: '/docs/double-entry'
      path: '/double-entry'
      fullPath: '/docs/double-entry'
      preLoaderRoute: typeof DocsDoubleEntryRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/contribution-room': {
      id: '/docs/contribution-room'
      path: '/contribution-room'
      fullPath: '/docs/contribution-room'
      preLoaderRoute: typeof DocsContributionRoomRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/bills': {
      id: '/docs/bills'
      path: '/bills'
      fullPath: '/docs/bills'
      preLoaderRoute: typeof DocsBillsRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/automating': {
      id: '/docs/automating'
      path: '/automating'
      fullPath: '/docs/automating'
      preLoaderRoute: typeof DocsAutomatingRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/ai-insights': {
      id: '/docs/ai-insights'
      path: '/ai-insights'
      fullPath: '/docs/ai-insights'
      preLoaderRoute: typeof DocsAiInsightsRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/accounts': {
      id: '/docs/accounts'
      path: '/accounts'
      fullPath: '/docs/accounts'
      preLoaderRoute: typeof DocsAccountsRouteImport
      parentRoute: typeof DocsRoute
    }
    '/analysis/$id': {
      id: '/analysis/$id'
      path: '/analysis/$id'
      fullPath: '/analysis/$id'
      preLoaderRoute: typeof AnalysisIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts/$id': {
      id: '/accounts/$id'
      path: '/$id'
      fullPath: '/accounts/$id'
      preLoaderRoute: typeof AccountsIdRouteImport
      parentRoute: typeof AccountsRoute
    }
  }
}

interface AccountsRouteChildren {
  AccountsIdRoute: typeof AccountsIdRoute
}

const AccountsRouteChildren: AccountsRouteChildren = {
  AccountsIdRoute: AccountsIdRoute,
}

const AccountsRouteWithChildren = AccountsRoute._addFileChildren(
  AccountsRouteChildren,
)

interface DocsRouteChildren {
  DocsAccountsRoute: typeof DocsAccountsRoute
  DocsAiInsightsRoute: typeof DocsAiInsightsRoute
  DocsAutomatingRoute: typeof DocsAutomatingRoute
  DocsBillsRoute: typeof DocsBillsRoute
  DocsContributionRoomRoute: typeof DocsContributionRoomRoute
  DocsDoubleEntryRoute: typeof DocsDoubleEntryRoute
  DocsFireRoute: typeof DocsFireRoute
  DocsFlowMapRoute: typeof DocsFlowMapRoute
  DocsImportingRoute: typeof DocsImportingRoute
  DocsInvestmentsRoute: typeof DocsInvestmentsRoute
  DocsPaymentGridRoute: typeof DocsPaymentGridRoute
  DocsPerformanceRoute: typeof DocsPerformanceRoute
  DocsReconciliationRoute: typeof DocsReconciliationRoute
  DocsReferenceRoute: typeof DocsReferenceRoute
  DocsIndexRoute: typeof DocsIndexRoute
}

const DocsRouteChildren: DocsRouteChildren = {
  DocsAccountsRoute: DocsAccountsRoute,
  DocsAiInsightsRoute: DocsAiInsightsRoute,
  DocsAutomatingRoute: DocsAutomatingRoute,
  DocsBillsRoute: DocsBillsRoute,
  DocsContributionRoomRoute: DocsContributionRoomRoute,
  DocsDoubleEntryRoute: DocsDoubleEntryRoute,
  DocsFireRoute: DocsFireRoute,
  DocsFlowMapRoute: DocsFlowMapRoute,
  DocsImportingRoute: DocsImportingRoute,
  DocsInvestmentsRoute: DocsInvestmentsRoute,
  DocsPaymentGridRoute: DocsPaymentGridRoute,
  DocsPerformanceRoute: DocsPerformanceRoute,
  DocsReconciliationRoute: DocsReconciliationRoute,
  DocsReferenceRoute: DocsReferenceRoute,
  DocsIndexRoute: DocsIndexRoute,
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountsRoute: AccountsRouteWithChildren,
  AccountsBrowserRoute: AccountsBrowserRoute,
  ActivityRoute: ActivityRoute,
  ActivityFeedRoute: ActivityFeedRoute,
  AdminUsersRoute: AdminUsersRoute,
  AllocationRoute: AllocationRoute,
  ApiDocsRoute: ApiDocsRoute,
  ApiTokensRoute: ApiTokensRoute,
  BillsRoute: BillsRoute,
  BudgetsRoute: BudgetsRoute,
  CategoriesRoute: CategoriesRoute,
  CategorizationRulesRoute: CategorizationRulesRoute,
  ConnectionsRoute: ConnectionsRoute,
  ConsolidatedHoldingsRoute: ConsolidatedHoldingsRoute,
  ContributionRoomRoute: ContributionRoomRoute,
  DashboardRoute: DashboardRoute,
  DemoRoute: DemoRoute,
  DividendsRoute: DividendsRoute,
  DocsRoute: DocsRouteWithChildren,
  ExtensionsRoute: ExtensionsRoute,
  FeesRoute: FeesRoute,
  FireRoute: FireRoute,
  FlowRoute: FlowRoute,
  GoalsRoute: GoalsRoute,
  HoldingsRoute: HoldingsRoute,
  HouseholdRoute: HouseholdRoute,
  ImportExportRoute: ImportExportRoute,
  InvestmentPlanRoute: InvestmentPlanRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  NetWorthRoute: NetWorthRoute,
  PaymentGridRoute: PaymentGridRoute,
  PerformanceRoute: PerformanceRoute,
  PortfolioRoute: PortfolioRoute,
  PricingRoute: PricingRoute,
  ProfileRoute: ProfileRoute,
  RecommendationsRoute: RecommendationsRoute,
  RecurringTransactionsRoute: RecurringTransactionsRoute,
  RegisterRoute: RegisterRoute,
  ReportsRoute: ReportsRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  RiskRoute: RiskRoute,
  SettingsAiRoute: SettingsAiRoute,
  SnapshotsRoute: SnapshotsRoute,
  TimelineRoute: TimelineRoute,
  TransactionsRoute: TransactionsRoute,
  VerifyRoute: VerifyRoute,
  AnalysisIdRoute: AnalysisIdRoute,
  AnalysisIndexRoute: AnalysisIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
